import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { checkedState, unCheckedState, setValuesmanageTerminologyList } from './manageTerminologySlice';
import { getValueFromResource } from "../../../common/timeLiveFunction";
const ManageTerminologyTable = (props: any) => {
  const { manageTerminologyList, t } = props;

  // const { selectedRecord, isLoading } = useAppSelector((state) => state.holidayType);
  // const [currentFieldsData, setCurrentFieldsData] = useState<any>(manageTerminologyList);
  const dispatch = useAppDispatch();
  // const [isChecked, setIsChecked] = useState(false);


  const handleCheckboxChange = (e: any, rowId: any) => {
    if (e.target.checked) {
      dispatch(checkedState(rowId))
    } else {
      dispatch(unCheckedState(rowId))
    }
  };

  const handleChange = (e: any, value: any, FieldName: string) => {
    dispatch(setValuesmanageTerminologyList({ "Index": value, "value": e.target.value, FieldName }));
  };

  return (
    <>
      {/* <table className="gvtabletodt table table-striped table-bordered order-column" > */}
      <table className="table table-row-bordered  align-middle gs-1 gy-2 gx-1" >
        <thead>
          <tr className="thHeading align-middle "  >
            <th className='w-50'>
              {/* {t('Terminology Name')} */}
              {getValueFromResource('Terminology Name',dispatch, t)}
              </th>
            <th className='w-50'>
              {/* {t('User Defined Name')} */}
              {getValueFromResource('User Defined Name',dispatch, t)}

              </th>
            <th className='w-0 text-center'>
              {/* {t('Selected')} */}
              {getValueFromResource('Selected',dispatch, t)}

              </th>
          </tr></thead>
        <tbody>
          {manageTerminologyList.map((manageTerminologyObj: any, index: number) => (
            <tr >
              <td style={{ width: "48.5%" }}>
                <input
                  // className="form-control input-disp-valid" 
                  className="form-control fs-7 fw-normal"
                  style={{ color: '#172b4d' }}
                  id="TerminologyName"
                  value={manageTerminologyObj.TerminologyName}
                  onChange={(e) => handleChange(e, index, 'TerminologyName')}


                />
              </td>
              <td style={{ width: "48.5%" }}>
                <input
                  // className="form-control input-disp-valid" 
                  className="form-control fs-7 fw-normal"
                  style={{ color: '#172b4d' }}
                  id="UserDefinedName"
                  value={manageTerminologyObj.UserDefinedName}
                  onChange={(e) => handleChange(e, index, 'UserDefinedName')}


                />
              </td>
              <td >
                <div className="form-check form-switch form-check-custom " >
                  <input
                    className="form-check-input h-15px w-30px"
                    type="checkbox"
                    checked={manageTerminologyObj.isSelected == 1 ? true : false}
                    onChange={(e) => { handleCheckboxChange(e, index) }}
                    

                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default ManageTerminologyTable